function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuNew = function SvgMenuNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "175px",
    height: "42px",
    viewBox: "0 0 175 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 40.917969 17.269531 L 32.046875 15.582031 L 23.671875 27.285156 L 18.601562 34.621094 L 7.125 28.363281 L 7.125 32.429688 L 23.523438 41.996094 L 28.074219 39.355469 L 28.097656 28.6875 L 33.441406 21.34375 L 33.441406 36.242188 L 40.960938 31.886719 Z M 40.917969 17.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,73.72549%,60%)",
      fillOpacity: 1
    },
    d: "M 30.941406 9.535156 L 13.589844 0.00390625 L 27.570312 2.394531 L 44.921875 11.921875 Z M 30.941406 9.535156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,84.313725%,76.078431%)",
      fillOpacity: 1
    },
    d: "M 30.945312 9.535156 L 44.925781 11.921875 L 43.921875 14.296875 L 31.105469 11.945312 L 18.421875 29.636719 L 17.351562 28.488281 L 30.941406 9.53125 Z M 30.945312 9.535156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,73.72549%,60%)",
      fillOpacity: 1
    },
    d: "M 18.421875 29.636719 L 1.070312 20.101562 L 0 18.957031 L 17.351562 28.492188 Z M 18.421875 29.636719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 17.351562 28.492188 L 0 18.960938 L 13.589844 0.00390625 L 30.941406 9.535156 Z M 17.351562 28.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 53.039062 4.296875 L 57.785156 4.296875 L 66.707031 17.902344 L 66.859375 17.902344 L 66.859375 4.296875 L 71.601562 4.296875 L 71.601562 25.71875 L 66.859375 25.71875 L 57.9375 12.109375 L 57.785156 12.109375 L 57.785156 25.71875 L 53.039062 25.71875 Z M 53.039062 4.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 75.238281 20.890625 L 75.238281 13.738281 L 72.925781 13.738281 L 72.925781 10.027344 L 75.238281 10.027344 L 75.238281 6.015625 L 79.894531 6.015625 L 79.894531 10.027344 L 83.167969 10.027344 L 83.167969 13.738281 L 79.894531 13.738281 L 79.894531 20.132812 C 79.894531 20.917969 80.34375 21.761719 81.757812 21.761719 C 82.117188 21.761719 82.65625 21.699219 83.230469 21.519531 L 83.230469 25.082031 C 82.628906 25.683594 81.304688 25.894531 80.226562 25.894531 C 77.34375 25.894531 75.238281 24.476562 75.238281 20.886719 Z M 75.238281 20.890625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 95.242188 16.335938 C 94.914062 14.523438 93.320312 13.648438 91.757812 13.648438 C 90.195312 13.648438 88.632812 14.460938 88.121094 16.335938 Z M 83.738281 17.898438 C 83.738281 12.59375 87.675781 9.722656 91.699219 9.722656 C 95.726562 9.722656 100.324219 12.5 99.328125 19.679688 L 88.214844 19.679688 C 88.84375 21.367188 90.40625 22.214844 92.480469 22.214844 C 93.863281 22.214844 95.09375 21.882812 96.238281 21.007812 L 98.339844 23.207031 C 97.046875 24.839844 94.824219 26.015625 91.96875 26.015625 C 87.644531 26.015625 83.738281 23.058594 83.738281 17.898438 Z M 83.738281 17.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 100.800781 10.027344 L 105.457031 10.027344 L 105.457031 14.285156 C 105.96875 11.75 107.46875 9.726562 110.292969 9.726562 C 110.652344 9.726562 111.011719 9.757812 111.40625 9.878906 L 111.40625 14.316406 C 111.046875 14.253906 110.714844 14.226562 110.324219 14.226562 C 107.234375 14.226562 105.457031 16.308594 105.457031 19.261719 L 105.457031 25.71875 L 100.800781 25.71875 Z M 100.800781 10.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 113.085938 4.296875 L 115.699219 4.296875 L 127.65625 21.371094 L 127.808594 21.371094 L 127.808594 4.296875 L 130.390625 4.296875 L 130.390625 25.71875 L 127.777344 25.71875 L 115.820312 8.644531 L 115.667969 8.644531 L 115.667969 25.71875 L 113.085938 25.71875 Z M 113.085938 4.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 140.542969 23.691406 C 143.429688 23.691406 146.132812 21.582031 146.132812 17.871094 C 146.132812 14.160156 143.429688 12.050781 140.542969 12.050781 C 137.660156 12.050781 134.957031 14.160156 134.957031 17.871094 C 134.957031 21.582031 137.660156 23.691406 140.542969 23.691406 Z M 132.433594 17.871094 C 132.433594 12.621094 136.488281 9.722656 140.542969 9.722656 C 144.601562 9.722656 148.65625 12.621094 148.65625 17.871094 C 148.65625 23.121094 144.601562 26.019531 140.542969 26.019531 C 136.488281 26.019531 132.433594 23.121094 132.433594 17.871094 Z M 132.433594 17.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.392157%,0.392157%,0.392157%)",
      fillOpacity: 1
    },
    d: "M 161.871094 13.105469 L 156.976562 25.71875 L 154.632812 25.71875 L 148.746094 10.027344 L 151.296875 10.027344 L 155.835938 22.550781 L 160.671875 10.027344 L 163.074219 10.027344 L 167.910156 22.550781 L 172.445312 10.027344 L 175 10.027344 L 169.113281 25.71875 L 166.769531 25.71875 Z M 161.871094 13.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 55.609375 37.558594 L 53.574219 30.253906 L 55.109375 30.253906 L 56.441406 35.5 L 56.511719 35.5 L 57.828125 30.253906 L 59.304688 30.253906 L 60.625 35.5 L 60.699219 35.5 L 62.015625 30.253906 L 63.550781 30.253906 L 61.527344 37.558594 L 59.957031 37.558594 L 58.609375 32.394531 L 58.535156 32.394531 L 57.171875 37.558594 L 55.605469 37.558594 Z M 55.609375 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 64.550781 37.558594 L 64.550781 30.253906 L 66.078125 30.253906 L 66.089844 33.246094 L 69.246094 33.246094 L 69.238281 30.253906 L 70.785156 30.253906 L 70.785156 37.558594 L 69.238281 37.558594 L 69.246094 34.480469 L 66.089844 34.480469 L 66.078125 37.558594 Z M 64.550781 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 74.417969 37.558594 L 74.417969 34.804688 L 71.734375 30.253906 L 73.363281 30.253906 L 75.152344 33.394531 L 75.214844 33.394531 L 77 30.253906 L 78.632812 30.253906 L 75.949219 34.804688 L 75.949219 37.558594 L 74.414062 37.558594 Z M 74.417969 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 83.339844 37.558594 L 81.304688 30.253906 L 82.839844 30.253906 L 84.171875 35.5 L 84.242188 35.5 L 85.558594 30.253906 L 87.035156 30.253906 L 88.355469 35.5 L 88.425781 35.5 L 89.746094 30.253906 L 91.28125 30.253906 L 89.257812 37.558594 L 87.6875 37.558594 L 86.335938 32.394531 L 86.265625 32.394531 L 84.902344 37.558594 L 83.335938 37.558594 Z M 83.339844 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 93.765625 34.722656 L 96.007812 34.722656 L 94.917969 31.867188 L 94.84375 31.867188 Z M 91.085938 37.558594 L 93.996094 30.253906 L 95.769531 30.253906 L 98.679688 37.558594 L 97.132812 37.558594 L 96.492188 35.960938 L 93.28125 35.960938 L 92.640625 37.558594 Z M 91.085938 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 99.519531 30.257812 L 101.046875 30.257812 L 101.046875 37.5625 L 99.519531 37.5625 Z M 99.519531 30.257812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 104.214844 37.558594 L 104.222656 31.496094 L 102.019531 31.496094 L 102 30.253906 L 107.941406 30.253906 L 107.953125 31.496094 L 105.761719 31.496094 L 105.75 37.558594 Z M 104.214844 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 110.496094 36.089844 L 111.929688 36.089844 L 111.929688 37.5625 L 110.496094 37.5625 Z M 110.445312 35.460938 L 110.445312 34.765625 C 110.445312 33.011719 112.480469 33.484375 112.480469 32.136719 C 112.480469 31.6875 112.011719 31.355469 111.375 31.355469 C 110.679688 31.355469 110.277344 31.730469 110.214844 32.460938 L 108.769531 32.460938 C 108.726562 31.125 109.789062 30.117188 111.367188 30.117188 C 112.945312 30.117188 113.992188 30.949219 113.992188 32.117188 C 113.992188 32.929688 113.527344 33.609375 112.726562 33.972656 C 112.125 34.253906 111.976562 34.398438 111.976562 34.882812 L 111.976562 35.464844 L 110.441406 35.464844 Z M 110.445312 35.460938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 119.199219 37.558594 L 119.207031 31.496094 L 117.007812 31.496094 L 116.988281 30.253906 L 122.929688 30.253906 L 122.9375 31.496094 L 120.746094 31.496094 L 120.734375 37.558594 Z M 119.199219 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 128.710938 33.96875 L 128.710938 33.855469 C 128.710938 32.757812 128.203125 31.339844 126.738281 31.347656 C 125.242188 31.359375 124.746094 32.757812 124.746094 33.855469 L 124.746094 33.96875 C 124.746094 35.097656 125.242188 36.453125 126.738281 36.464844 C 128.203125 36.472656 128.710938 35.097656 128.710938 33.96875 Z M 123.207031 33.96875 L 123.207031 33.867188 C 123.207031 32.144531 124.203125 30.113281 126.742188 30.113281 C 129.277344 30.113281 130.21875 32.144531 130.21875 33.867188 L 130.21875 33.96875 C 130.21875 35.722656 129.292969 37.707031 126.742188 37.707031 C 124.1875 37.707031 123.207031 35.722656 123.207031 33.96875 Z M 123.207031 33.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 131.390625 34.546875 L 131.390625 30.257812 L 132.917969 30.257812 L 132.917969 34.691406 C 132.917969 35.648438 133.425781 36.453125 134.496094 36.464844 C 135.542969 36.472656 136.066406 35.648438 136.066406 34.691406 L 136.066406 30.257812 L 137.582031 30.257812 L 137.582031 34.546875 C 137.582031 36.296875 136.605469 37.707031 134.496094 37.707031 C 132.386719 37.707031 131.390625 36.285156 131.390625 34.546875 Z M 131.390625 34.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 140.59375 33.480469 L 142.230469 33.480469 C 142.980469 33.480469 143.425781 33.207031 143.425781 32.488281 C 143.425781 31.769531 142.988281 31.496094 142.230469 31.496094 L 140.59375 31.496094 Z M 139.066406 37.558594 L 139.066406 30.253906 L 142.304688 30.253906 C 144 30.253906 144.964844 30.972656 144.964844 32.488281 C 144.964844 33.582031 144.425781 34.292969 143.488281 34.546875 L 144.964844 37.5625 L 143.429688 37.5625 L 142.027344 34.722656 L 140.59375 34.722656 L 140.59375 37.5625 L 139.066406 37.5625 Z M 139.066406 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 148.425781 37.558594 L 148.425781 30.253906 L 150.105469 30.253906 L 153.042969 35.199219 L 153.09375 35.199219 L 153.09375 30.253906 L 154.632812 30.253906 L 154.632812 37.558594 L 152.9375 37.558594 L 150.007812 32.625 L 149.949219 32.625 L 149.949219 37.558594 L 148.421875 37.558594 Z M 148.425781 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 161.289062 33.96875 L 161.289062 33.855469 C 161.289062 32.757812 160.78125 31.339844 159.316406 31.347656 C 157.820312 31.359375 157.324219 32.757812 157.324219 33.855469 L 157.324219 33.96875 C 157.324219 35.097656 157.820312 36.453125 159.316406 36.464844 C 160.78125 36.472656 161.289062 35.097656 161.289062 33.96875 Z M 155.785156 33.96875 L 155.785156 33.867188 C 155.785156 32.144531 156.785156 30.113281 159.320312 30.113281 C 161.855469 30.113281 162.796875 32.144531 162.796875 33.867188 L 162.796875 33.96875 C 162.796875 35.722656 161.871094 37.707031 159.320312 37.707031 C 156.765625 37.707031 155.785156 35.722656 155.785156 33.96875 Z M 155.785156 33.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 165.25 37.558594 L 163.214844 30.253906 L 164.75 30.253906 L 166.082031 35.5 L 166.152344 35.5 L 167.46875 30.253906 L 168.945312 30.253906 L 170.265625 35.5 L 170.339844 35.5 L 171.65625 30.253906 L 173.191406 30.253906 L 171.167969 37.558594 L 169.597656 37.558594 L 168.25 32.394531 L 168.175781 32.394531 L 166.8125 37.558594 L 165.246094 37.558594 Z M 165.25 37.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,34.117647%,0%)",
      fillOpacity: 1
    },
    d: "M 173.335938 37.558594 L 173.335938 35.886719 L 175 35.886719 L 174.992188 37.558594 Z M 173.335938 37.558594 "
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-new.b52825ef.svg";
export { ForwardRef as ReactComponent };